import { PercentMaskProcessing } from './percent';

export class PercentWithDecimalsMaskProcessing extends PercentMaskProcessing {
  protected allowedDecimals = 2;
  protected min = 0;
}
